import React from 'react'

const Dashboard = () => {
  return (
    <div className='jumbotron'>
      <h1>
        Welcome to Bohol Island State University -{' '}
        <small>
          Integrated School Management and Information System (ISMIS)
        </small>
      </h1>
      <div className='embed-responsive embed-responsive-16by9'>
        <iframe
          className='embed-responsive-item'
          src='https://slides.com/phillipglennlibay/ismis-user-guide/embed?style=light'
        ></iframe>
      </div>
    </div>
  )
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js